/**
 * Utility functions for ZoomModalIconComponent
 */

import { translate } from '@core/i18n/window-language';
import { ZOOM_MODAL_WEB_COMPONENT } from '@components/modals/ZoomModalComponent/CONSTANTS';
import { ACTIVE_ID_ATTRIBUTE } from '@core/constants/ATTRIBUTES';
import { TOOLTIP_POSITION } from '@components/TooltipComponent/CONSTANTS';

/**
 * Update tooltip content with translated text
 * @param {HTMLParagraphElement} tooltipElement - The tooltip element to update
 * @returns {void}
 */
export function updateTooltipContent(tooltipElement) {
    if (tooltipElement) {
        tooltipElement.innerText = translate('tooltip.zoomModal');
    }
}

/**
 * Apply tooltip positioning based on position and flex grow values
 * @param {HTMLElement} tooltipContainer - The tooltip container element
 * @param {string} tooltipPosition - The tooltip position
 * @param {number} customFlexGrow - The custom flex grow value
 * @param {boolean} zoomIn - The zoom in value
 * @returns {void}
 */
export function applyTooltipPositioning(
    tooltipContainer,
    tooltipPosition,
    customFlexGrow,
    zoomIn,
) {
    if (!tooltipContainer) return;

    switch (tooltipPosition) {
        case TOOLTIP_POSITION.BOTTOM_RIGHT:
            tooltipContainer.style.right = `${Math.min(customFlexGrow * 0.5, 40)}%`;
            tooltipContainer.style.setProperty('top', '40px', 'important');
            break;
        case TOOLTIP_POSITION.BOTTOM_LEFT:
            tooltipContainer.style.left = `${Math.min(customFlexGrow * 0.5, 40)}%`;
            tooltipContainer.style.right = 'unset';
            break;
        case TOOLTIP_POSITION.TOP_RIGHT:
            tooltipContainer.style.setProperty(
                'top',
                `-${Math.min(customFlexGrow * 0.5, 40)}px`,
                'important',
            );
            break;
        case TOOLTIP_POSITION.TOP_LEFT:
            tooltipContainer.style.right = zoomIn ? '25px' : '45px';
            tooltipContainer.style.setProperty('top', '0', 'important');
            break;
        default:
            break;
    }
}

/**
 * Handle zoom modal click event
 * @param {string} activeId - The active ID to set on the modal
 * @returns {void}
 */
export function handleZoomModalClick(activeId) {
    let zoomModal = document.querySelector(ZOOM_MODAL_WEB_COMPONENT);

    if (!zoomModal) {
        document.body.appendChild(document.createElement(ZOOM_MODAL_WEB_COMPONENT));
        zoomModal = document.querySelector(ZOOM_MODAL_WEB_COMPONENT);
    }

    zoomModal.setAttribute(ACTIVE_ID_ATTRIBUTE, activeId);
    zoomModal.showModal();
}
